'use client';
import { createClient } from '@/lib/supabase/client';

type EventType = 'page_view' | 'click' | 'app_download';

let sessionId: string | null = null;

function getSessionId(): string {
  if (sessionId) return sessionId;
  try {
    const stored = sessionStorage.getItem('chance_session_id');
    if (stored) { sessionId = stored; return sessionId; }
    const newId = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem('chance_session_id', newId);
    sessionId = newId;
    return sessionId;
  } catch {
    sessionId = Math.random().toString(36).slice(2);
    return sessionId;
  }
}

export async function trackEvent(eventType: EventType, metadata: Record<string, any> = {}) {
  try {
    const supabase = createClient();
    const today = new Date().toISOString().split('T')[0];

    // Insert raw event
    await supabase.from('analytics_events').insert({
      event_type: eventType,
      session_id: getSessionId(),
      metadata,
    });

    // Upsert daily summary
    await supabase.rpc('upsert_analytics_daily', {
      p_event_type: eventType,
      p_event_date: today,
    });
  } catch {
    // Silently fail — analytics should never break the app
  }
}

export function trackPageView() {
  trackEvent('page_view', { path: typeof window !== 'undefined' ? window.location.pathname : '/' });
}

export function trackClick(label: string) {
  trackEvent('click', { label });
}

export function trackAppDownload() {
  trackEvent('app_download', { source: 'main_page' });
}

export function trackMetaPixelDownload() {
  try {
    if (typeof window !== 'undefined' && typeof (window as any).fbq === 'function') {
      (window as any).fbq('track', 'Lead');
      (window as any).fbq('track', 'Download');
    }
  } catch {
    // Silently fail
  }
}
